import React, { useEffect, useRef } from "react";

// SASS
import "./Part4.scss";

// COMPONENTS
import Step from "../Step/Step";

// HELPERS
import animate from "../../utils/animate";

// LIBRARIES
import scrollama from "scrollama";

// ASSETS
import copierImg from "../../assets/img/copy-machine.png";
import virusCopyImg from "../../assets/img/virus-sticky-note-4.png";

// FUNCTION EXPORT
export default function Part({ step }) {
  // SCROLLAMA INSTANCE
  const scrolly = scrollama();

  // ANIMATION STEP DATA
  const animationSequence = [
    { stepNumber: "0", height: null, description: "spacer" },
    {
      stepNumber: "1",
      height: null,
      description: "move virus 1, fade in virus 2, 3, 4",
    },
    { stepNumber: "2", height: null, description: "move virus 2" },
    { stepNumber: "3", height: null, description: "move virus 3" },
    { stepNumber: "4", height: null, description: "move virus 4" },
    { stepNumber: "5", height: null, description: "spacer" },
  ];

  // REFS
  const virus1El = useRef(null);
  const virus2El = useRef(null);
  const virus3El = useRef(null);
  const virus4El = useRef(null);
  const part4El = useRef(null);

  // RUN WHEN THE COMPONENT MOUNTS
  useEffect(() => {
    scrolly
      .setup({
        step: `.${step}`,
        debug: false,
        threshold: 1,
        progress: true,
      })
      .onStepEnter(({ element, direction }) => {
        const step = element.dataset.step;
        switch (step) {
          case "1": {
            animate.addClassOnEnter(virus1El.current, "moved", direction);
            setTimeout(() => {
              fadeInVirusCopies(direction);
            }, 500);
            break;
          }
          case "2": {
            animate.addClassOnEnter(virus2El.current, "moved", direction);
            break;
          }
          case "3": {
            animate.addClassOnEnter(virus3El.current, "moved", direction);
            break;
          }
          case "4": {
            animate.addClassOnEnter(virus4El.current, "moved", direction);
            break;
          }
          case "6": {
            animate.fadeOutOnEnter(part4El.current, direction);
            break;
          }
          default:
            break;
        }
      })
      .onStepProgress(({ element, progress }) => {
        const step = element.dataset.step;
        switch (step) {
          default:
            break;
        }
      })
      .onStepExit(({ element, direction }) => {
        const step = element.dataset.step;
        switch (step) {
          case "1": {
            animate.removeClassOnExit(virus1El.current, "moved", direction);
            fadeOutVirusCopies(direction);
            break;
          }
          case "2": {
            animate.removeClassOnExit(virus2El.current, "moved", direction);
            break;
          }
          case "3": {
            animate.removeClassOnExit(virus3El.current, "moved", direction);
            break;
          }
          case "4": {
            animate.removeClassOnExit(virus4El.current, "moved", direction);
            break;
          }
          case "6": {
            animate.fadeInOnExit(part4El.current, direction);
            // animate.changeBodyBgColorUp("#003366", direction);
            // if (direction === "up") setCurrentVirusPart("genes");
            break;
          }
          default:
            break;
        }
      });
  }, [scrolly, step]);

  // CUSTOM FUNCTIONS

  const fadeInVirusCopies = (direction) => {
    if (direction === "down") {
      [virus2El.current, virus3El.current, virus4El.current].forEach(
        (virus) => {
          virus.style.opacity = 1;
        }
      );
    }
  };

  const fadeOutVirusCopies = (direction) => {
    if (direction === "up") {
      [virus2El.current, virus3El.current, virus4El.current].forEach(
        (virus) => {
          virus.style.opacity = 0;
        }
      );
    }
  };

  return (
    <section className="wrapper">
      <div className="sticky-container">
        {/* STICKY */}
        <div className="part4" ref={part4El}>
          <div className="top-text">
            These genes contain the information to make more virus copies.
          </div>
          <div className="copier-container">
            <div className="copier">
              <img src={copierImg} alt="" className="img-fluid" />
            </div>
            <div className="virus-copy virus-copy-1" ref={virus1El}>
              <img src={virusCopyImg} alt="" className="img-fluid" />
            </div>
            <div className="virus-copy virus-copy-2" ref={virus2El}>
              <img src={virusCopyImg} alt="" className="img-fluid" />
            </div>

            <div className="virus-copy virus-copy-3" ref={virus3El}>
              <img src={virusCopyImg} alt="" className="img-fluid" />
            </div>

            <div className="virus-copy virus-copy-4" ref={virus4El}>
              <img src={virusCopyImg} alt="" className="img-fluid" />
            </div>
          </div>
        </div>
      </div>

      {/* STEPS */}
      {animationSequence.map(({ stepNumber, height, description, offset }) => {
        return (
          <Step
            stepSection={step}
            stepNumber={stepNumber}
            stepDescription={description}
            height={height}
            key={stepNumber}
            offset={offset}
          />
        );
      })}
    </section>
  );
}
